export const PREPROCESSING_DATA = 'PREPROCESSING_DATA';
export const EXTRACTION_PROCESS = 'EXTRACTION_PROCESS';
